<template>
    <div>
        <LinedHeader :text="linkText" />
        <ul class="md:flex md:flex-wrap text-left content-evenly -m-4">
            <li v-for="result in results" :key="result.url" class="w-full md:w-1/3 lg:w-1/4 p-4">
                <a :href="result.url" class="flex flex-col h-full w-full bg-white  border-t-6 shadow hover:shadow-sm" :class="[`border-${result.color}-500`]">
                    <img :src="`${result.image}?${imageParams}&${result.imageResizerParams}`">
                    <div class="px-2 pt-2 font-bold">{{ result.title }}</div>
                    <div class="mt-auto p-2 text-xs text-grey-300">Publisert: {{ new Date(result.publishDate).toLocaleDateString('nb-NO', dateOptions) }}</div>
                </a>
            </li>
        </ul>
        <div class="text-right my-4 w-full" v-if="latestPublishedPageUrl !== null">
            <EpiLink :url="latestPublishedPageUrl" className="inline-block text-lg rounded-full bg-green-700 hover:bg-blue-700 text-white px-6 py-2">
                Vis flere &#10095;
            </EpiLink>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import LinedHeader from '@/Scripts/components/atoms/LinedHeader/LinedHeader.vue';

export default {
    props: ['results','model'],
    components: {
        EpiLink,
        LinedHeader,
    },
    data() {
        return {
            imageParams: 'scale=both&width=576&height=359',
            latestPublishedPageUrl: null,
            dateOptions: { year: 'numeric', month: '2-digit', day: '2-digit' },
            linkText: 'Nye publiseringer'
        };
    },
    mounted() {
        this.latestPublishedPageUrl = (this.model.latestPublishedPageUrl && this.model.latestPublishedPageUrl.value && this.model.latestPublishedPageUrl.value.url) ? this.model.latestPublishedPageUrl.value.url : null;
    },
};
</script>
